<template>
	<div
		class="flex flex-col app-input-container"
		:class="{ 'has-error': validation.errors.length > 0, [containerClass]: containerClass, [name]: !!name }"
	>
		<div class="relative w-full justify-center">
			<transition name="slide-fade" mode="out-in">
				<app-label
					v-if="modelValue !== null && modelValue !== undefined && modelValue !== '' && !hideLabel"
					:for="name"
					:color="validation.errors.length > 0 ? 'primary' : 'secondary'"
				>
					{{ placeholder }}
				</app-label>
			</transition>
			<app-icon
				v-if="!!icon && !loading"
				class="app-input-icon"
				style="line-height: 38px; right: 12px; left: auto;"
				:icon="icon"
			/>
			<input
				class="app-input"
				:class="[!!icon ? 'pr-10' : '', loading ? 'pr-10' : '']"
				v-bind="$attrs"
				:placeholder="placeholder"
				:value="modelValue"
				:disabled="loading || !!$attrs.disabled"
				@input="debouncedChange"
				@blur="validation.setTouched && validation.setTouched(true)"
			/>
			<div v-if="loading" class="absolute inset-y-0 right-0 pr-2 flex items-center pointer-events-none">
				<span class="h-4 w-4 rounded-full border-2 border-secondary border-t-transparent animate-spin" />
			</div>
			<transition name="slide-fade-reverse">
				<span
					class="error-message text-13 text-error"
					v-if="(validation.meta.touched || validation.errors.length > 0) && !hideLabel"
				>
					{{ validation.errorMessage }}
				</span>
			</transition>
		</div>
	</div>
</template>

<script>
	import AppLabel from '@/components/typography/AppLabel';
	import AppIcon from '@/components/app/AppIcon';
	import { debounce } from 'lodash';

	export default {
		name: 'AppInput',
		components: {
			AppLabel,
			AppIcon,
		},
		emits: ['update:modelValue'],
		props: {
			icon: {
				type: String,
				default: null,
			},
			name: {
				type: String,
				required: true,
			},
			placeholder: {
				type: String,
				default: '',
			},
			debounceInterval: {
				type: Number,
				default: 0,
			},
			loading: {
				type: Boolean,
				default: false,
			},
			modelValue: {},
			validation: {
				type: Object,
				default: () => ({
					meta: {},
					errors: [],
				}),
			},
			hideLabel: {
				type: Boolean,
				default: false,
			},
			containerClass: {},
		},
		methods: {
			onChange(event) {
				const value =
					this.$attrs.type === 'number'
						? parseFloat(parseFloat(event.target.value).toFixed(2)) || 0
						: event.target.value;
				this.$emit('update:modelValue', value);
			},
		},
		created() {
			this.debouncedChange = debounce(this.onChange, this.debounceInterval);
		},
	};
</script>
